import React from 'react';
import thumbnail from './material/thumbnail.png';
import poster from './material/UIST_Poster.pdf';
import posterDesign from './material/UIST_Poster_Design.pdf';
import uist2026 from './material/uist2026.svg';

const adaptiveCue2026 = {
  id: 'adaptivecue-2026',
  year: 2026,
  title: (
    <>
      <i className="rainbow-text">AdaptiveCue</i>
      : Team-Customized Cue Tags for Live Collaborative Planning
    </>
  ),
  altTitle: 'AdaptiveCue: Team-Customized Cue Tags for Live Collaborative Planning',
  authors: [
    { name: 'Yuhan Zeng' },
    { name: 'Shiwei Wu', url: 'https://shionming.github.io/shiweiwu.github.io/' },
    { name: 'Nuwan Janaka', url: 'https://nuwanjanaka.info/' },
    { name: 'Hei Ching Iu' },
    { name: 'Fiona Nah', url: 'https://faculty.smu.edu.sg/profile/nah-fiona-fui-hoon-7861' },
    { name: 'Jiannan Li', url: 'https://jchrisli.github.io/' },
  ],
  thumbnail,
  keywords: ['Intelligent Collaborative Systems', 'Proactive AI', 'Large Language Models', 'Social Dynamics', 'Decision-Making', 'Intent-Centered Computing'],
  cueTags: true,
  cueTagViewer: 'Alice',
  cueTagInterval: 4500,
  awards: [],
  links: [
    { label: '[Poster]', url: poster },
    { label: '[Poster Design]', url: posterDesign },
  ],
  venue: 'ACM UIST Adjunct 2026',
  fullVenue: 'The ACM Symposium on User Interface Software and Technology',
  venueLogo: uist2026,
};

export default adaptiveCue2026;
